import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, FormGroup, FormControl } from 'react-bootstrap';

const SavedJobFilter = ({ filters, updateFilter }) => {
  const onUpdateNameSearch = e => updateFilter('nameSearch', e.target.value);

  return (
    <Row>
      <Col md={12}>
        <FormGroup>
          <FormControl
            type='text'
            placeholder='SEARCH JOB NAMES'
            value={filters.nameSearch}
            onChange={onUpdateNameSearch}
          />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default SavedJobFilter;

SavedJobFilter.propTypes = {
  filters: PropTypes.shape({ nameSearch: PropTypes.string }),
  updateFilter: PropTypes.func,
};
